import { Buffer } from 'buffer';
import axios from 'axios';
import { getBuyersUrl, getBuyerHeaders } from 'shared/http/';
import { Component } from 'react';
import { Form, Button, Spinner, Modal, Nav, OverlayTrigger, Tooltip} from 'react-bootstrap';

// project imports
import { ACCESS_TOKEN, REFRESH_TOKEN } from 'shared/settings/token';
import { loginWithRes } from 'shared/settings/auth';
import Validators from 'shared/validators';
import store from 'features/store';
import AuthService from 'shared/services/authService';
import { mobileNumberFormat } from 'shared/modifiers';
import { rightArrow, check } from 'shared/assets/icons';
// style imports
import authService from 'shared/services/authService';

import './Signin.scss';
import { showAndHideJiraButton } from 'shared/jira-button';
import { authErrorMessage } from 'features/config/systemmessages';
import { SignTermsAndCondtions } from '../base/public';
import { addDataLayer, getFormattedAppleLinkAndMessage, pmAutoNavigateToNextScreen, setPmSteps } from 'shared/utils/utils';
import { ScmSignin } from './ScmSignin';
import { banner1, banner2, banner3, banner4 } from 'shared/images/images';
import { isAuthorized } from 'shared/settings/auth';
import { SetPassword } from '../set-password/SetPassword';

export class BuyerRegister extends Component {

    constructor(props) {
        super(props);
        this.timeoutInterval = null;
        this.state = {
            // toggle input type
            showPassword: false,
            confirmPassword: false,
            reactiveBtn: false,
            timeLeft: 105,
            retry: false,
            // form
            formValid: false,
            formControls: {
                email: { value: '', valid: false, error: '', validators: [Validators.required(), Validators.email(), Validators.maxLength(60)] },
                password: { value: '', valid: false, error: '', validators: [Validators.required()] }
            },
            remember: false,
            errorMsg: '',
            nickNameErroMsg: '',
            nameError: true,
            tempVerifyPhoneNumber: '',
            phoneNumberDisabled: false,
            messagetype: true,
            userUpdateStatus: false,
            activeUserToken: '',
            showReactivationModel: false,
            acceptTerms: false,
            /* Register form control */
            registerFormControl: {
                firstname: { value: '', valid: false, error: '', validators: [Validators.required(), Validators.validateNameLength(1, 45, 'First Name')] },
                lastname: { value: '', valid: false, error: '', validators: [Validators.required(), Validators.validateNameLength(1, 45, 'Last Name')] },
                nickname: { value: '', valid: false, error: '', validators: [Validators.required(), Validators.validateNameLength(1, 45, 'User Name')] },
                email: { value: '', valid: false, error: '', validators: [Validators.required(), Validators.email(), Validators.maxLength(60)] },
                retypeEmail: { value: '', valid: false, error: '', validators: [Validators.required(), Validators.email(), Validators.maxLength(60)] },
                phonenumber: { value: '', valid: false, error: '', validators: [Validators.required(), Validators.mobile()] },
            },
            reactivationEmail: {
                value: '', valid: false, error: '', validators: [Validators.required(), Validators.email(), Validators.maxLength(60)]
            },
            showPhoneNumberModel: false,
            showDeletedSuccessMsg: false,
            reactivationMsg: '',
            mobileReacitvation: false,
            reactiveMobileNumber: false,
            passwordStrength: { status: 0, lower: false, upper: false, numeric: false, count: false, symbol: false },

            // loading
            signinFormLoading: false,
            toggleSignInModal: false,
            innerWidth: window.innerWidth,
            mobileModal: false,
            isOtpSent: false,
            mobile: {
                otp: { value: '', error: '', valid: false },
                valid: false
            },
            otpMessage: '',
            otpSuccess: false,
            isVerified: false,
            getOtpType: '',

            // Tab
            activeKey: "Sign-In",
            proxyEmail: false,
            welcomeMessageShow: false,
            displayname: null,
            signUpLading: false,
            disabledText: false,
            signInError: '',
            signUpError: '',

            // Check details
            details: {
                firstname: {
                    loading: false,
                    exists: false,
                    message: ""
                },
                lastname: {
                    loading: false,
                    exists: false,
                    message: ""
                },
                nickname: {
                    loading: false,
                    exists: false,
                    message: ""
                },
                email: {
                    loading: false,
                    exists: false,
                    message: ""
                }
            },
            signTermsConditions: false
        };
    }

    /**
     * 
     * Called after component mount
     * 
     */
    componentDidMount() {
        if(isAuthorized()) {
            this.props.history.push('/')
        }


        /* Adding event listenr for resize */
        window.addEventListener('resize', this.updateDimensions);

    }
    componentWillUnmount() {
        clearInterval(this.timer);
        window.removeEventListener('resize', this.updateDimensions);
    }

    /**
     * 
     * Called when resize the screen.
     * 
     */
    updateDimensions = () => {
        this.setState({
            ...this.state,
            innerWidth: window.innerWidth
        });
    }

    /* toggles password to show or hide on clicking eye icon */
    togglePassword = () => {
        this.setState({ showPassword: !this.state.showPassword });
    };

    /* toggles confirm password to show or hide on clicking eye icon */
    toggleConfirmPassword = () => {
        this.setState({ confirmPassword: !this.state.confirmPassword });
    };

    /* checks whether the input is valid or not */
    onInputValidation = (event, formName) => {
        let controlError = '';

        const validateName = (value) => {
            const alphabeticPattern = /^[a-zA-Z0-9\sáéíóúüñÁÉÍÓÚÜÑÊêÂâÎîÔôÛûËëÏïÜüòÒàÀèÈìÌùÙçÇ`']*$/;
            if (alphabeticPattern.test(value)) {
                return "";
            }
            else if (/[!@#$%^&*(),.?":{}|<>_\-+=~`[\]\\\/;'’]/.test(value)) {
                return event.target.name === "nickname" ? 'Please only use alphanumeric characters' : "This field only supports alphabetical characters.";
            } else {
                return "Please enter a valid character";
            }
        };

        let inputValue = event.target.value;
        if (event.target.name === "nickname") {
            inputValue = inputValue.replace(/\s+/g, '');
            if (!/^[a-zA-Z0-9]*$/.test(inputValue)) {
                const alphabeticPatternError = validateName(inputValue)
                if (alphabeticPatternError) {
                    controlError = alphabeticPatternError;
                }
            }
        }

        if (event.target.name === "firstname" || event.target.name === "lastname") {
            const alphabeticPatternError = validateName(inputValue)
            if (alphabeticPatternError) {
                controlError = alphabeticPatternError;
            }
        }

        // Proceed with other validators if no alphabeticPattern error
        if (!controlError) {
            for (let validator of this.state[formName][event.target.name].validators) {
                controlError = validator(inputValue);
                if (controlError) break;
            }
        }

        if ((event.target.name === 'firstname' || event.target.name === 'lastname')) {
            const nameRegex = /^[a-zA-Z\xC0-\uFFFF`]+([-'.\s]?[a-zA-Z\xC0-\uFFFF`]+)*$/g;
            if (/^\s+|\s+$/.test(inputValue)) {
                controlError = `Please delete any added spaces before or after your entry.`;
            }
            else if (/\d/.test(inputValue)) {
                controlError = `This field only supports alphabetical characters.`;
            }
        }

        /* sets the state of the control and form validity */
        this.setState({
            nameError: controlError ? false : true,
            [formName]: {
                ...this.state[formName],
                [event.target.name]: {
                    ...this.state[formName][event.target.name],
                    value: inputValue,
                    valid: !Boolean(controlError),
                    error: controlError
                }
            }
        },
            () => {
                /* check form validity */
                if (controlError) {
                    this.setState({ formValid: false });
                } else {
                    let formValid = true;
                    for (let control of Object.keys(this.state[formName])) {
                        if (!this.state[formName][control].valid) {
                            formValid = false;
                            break;
                        }
                    }
                    this.setState({ formValid: formValid });
                }
            });
        if (event.target.name == "nickname" || event.target.name === "firstname" || event.target.name === "lastname") {
            if (this.timeoutInterval) {
                clearTimeout(this.timeoutInterval);
            }
            this.timeoutInterval = setTimeout(() => {
                this.formatData(event, controlError);
            }, 1000);
        }

    }

    /* Email validation. Check email and retypeEmail are equal or not */
    emailValidation = (event, formName) => {

        let controlError = '';

        /* checks all the validators for the control */
        for (let validator of this.state[formName][event.target.name].validators) {
            controlError = validator(event.target.value);
            if (controlError) break;
        }
        if (event.target.name === "email") {
            this.setState({
                errorMsg: event.target.value ? this.state.errorMsg : '',
            })
        }

        /* Check confirm email is equal to email */
        if (event.target.name === 'retypeEmail' && (this.state.registerFormControl.email.value.toLowerCase() !== event.target.value.toLowerCase()) && !controlError) {
            controlError = "Email does not match"
        }

        /* sets the state of the control and form validity */
        this.setState({
            [formName]: {
                ...this.state[formName],
                [event.target.name]: {
                    ...this.state[formName][event.target.name],
                    value: event.target.value,
                    valid: !Boolean(controlError),
                    error: controlError
                }
            }
        },
            () => {
                /* check form validity */
                if (controlError) {
                    this.setState({ formValid: false });
                }
                else {
                    let formValid = true;
                    for (let control of Object.keys(this.state[formName])) {
                        if (!this.state[formName][control].valid) {
                            formValid = false;
                            break;
                        }
                    }
                    this.setState({ formValid: formValid });
                }

                let retypeEmailError = "Email does not match";
                /* Check confirm email is equal to email */
                if (event.target.name === 'email' && this.state.registerFormControl.retypeEmail.value && (this.state.registerFormControl.retypeEmail.value !== event.target.value)) {
                    this.setState({
                        [formName]: {
                            ...this.state[formName],
                            retypeEmail: {
                                ...this.state[formName].retypeEmail,
                                valid: !Boolean(retypeEmailError),
                                error: retypeEmailError
                            }
                        },
                        formValid: false
                    });
                } else if (event.target.name === 'email' && this.state.registerFormControl.retypeEmail.value && (this.state.registerFormControl.retypeEmail.value === event.target.value)) {
                    retypeEmailError = ""
                    this.setState({
                        [formName]: {
                            ...this.state[formName],
                            retypeEmail: {
                                ...this.state[formName].retypeEmail,
                                valid: !Boolean(retypeEmailError),
                                error: retypeEmailError
                            }
                        }
                    });
                }
                this.formatData(event, controlError);
            });
    }


    /* otp generated when mobile number changed */
    generateOtp = (flag) => {
        let value = this.state.registerFormControl.phonenumber.value.replace(/\D/g, '');
        this.setState({
            getOtpType: flag,
            mobileLoading: true,
        }, () => {
            const data = {
                "data": {
                    "mobile": value,
                    "otpvia": flag,
                }
            };
            AuthService.verifyMobileOtp(data).then(res => {
                this.setState({
                    isOtpSent: true,
                    mobileLoading: false,
                    otpMessage: ''
                });

            }).catch(error => {
                this.setState({
                    mobileLoading: false,
                    otpMessage: error.message
                })
            })

        });
    }

    submitOtp = () => {
        this.setState({
            reactiveBtn: true
        })
        let value = this.state.registerFormControl.phonenumber.value.replace(/\D/g, '');
        const data = {
            "data": {
                "mobile": value,
                "token": this.state.mobile.otp.value,
            }
        };
        AuthService.checkOtpVerify(data).then(res => {
            this.setState({
                otpMessage: 'The OTP is verified successfully. Please click on Sign Up to proceed with the registration.',
                otpSuccess: true,
                tempVerifyPhoneNumber: this.state.registerFormControl.phonenumber.value,
                activeUserToken: res.data?.data?.token
            });

            if (this.state.reactiveMobileNumber && !this.state.userUpdateStatus) {
                this.reactivation()
                setTimeout(() => {

                    this.setState(prevState => ({
                        ...this.state,
                        reactiveBtn: false,
                        mobile: {
                            ...this.state.mobile,
                            otp: {
                                ...this.state.mobile.otp,
                                value: ''
                            }
                        },
                        otpMessage: '',
                        isOtpSent: false,
                        otpSuccess: false,
                        showPhoneNumberModel: false,
             
                    }));

                }, 2000);

            }
            else {

                setTimeout(() => {
                    this.setState({
                        ...this.state,
                        phoneNumberDisabled: true,
                        showPhoneNumberModel: false,
                        reactiveBtn: false,
                        otpMessage: '',
                        isOtpSent: false,
                        otpSuccess: false,
                        isVerified: true,
                        mobile: {
                            ...this.state.mobile,
                            otp: {
                                ...this.state.mobile.otp,
                                value: ''
                            }
                        }
                    })
                }, 2000);
            }

        }).catch(error => {
            this.setState({
                otpMessage: error.message,
                otpSuccess: false,
                reactiveBtn: false,
            })
        })
    }

    updateUserFn = () => {
        const data = {
            data: {
                firstname: this.state.registerFormControl.firstname.value,
                lastname: this.state.registerFormControl.lastname.value,
                nickname: this.state.registerFormControl.nickname.value,
                email: this.state.registerFormControl.email.value,
                mobile: this.state.registerFormControl.phonenumber.value.replace(/\D/g, ''),
                token: this.state.activeUserToken
            }
        };
        AuthService.updateUser(data).then(res => {
            this.setState({
                signUpLading: false,
                welcomeMessageShow: true

            });

        }).catch(error => {
            this.setState({
                signUpLading: false,
                signUpError: error.message
            });
        })
    }

    resendOtpfn = () => {

        this.setState({
            resendOtp: true,
        })
        let value = this.state.registerFormControl.phonenumber.value.replace(/\D/g, '');
        const data = {
            "data": {
                "mobile": value,
                "otpvia": this.state.getOtpType,
            }
        };
        AuthService.resendOtp(data).then(res => {
            this.setState({
                ...this.state,
                otpSuccess: true,
                otpMessage: 'Resend OTP Successfully',
                resendOtp: false,
                mobile: {
                    ...this.state.mobile,
                    otp: {
                        ...this.state.mobile.otp,
                        value: ''
                    }
                }
            })
            setTimeout(() => {
                this.setState({
                    otpMessage: '',
                    resendOtp: false,

                })
            }, 1000);


        }).catch(error => {
            this.setState({
                otpSuccess: false,
                otpMessage: error.message,
                resendOtp: false,
            })
        })



    }

    phonenumberValidation = (event, formName) => {
        let inputError = '';
        if (event.target.name === 'phonenumber') {
            const eventValue = event.target.value ? mobileNumberFormat(event.target.value, this.state.registerFormControl.phonenumber.value) : '';
            event.target.value = eventValue ? eventValue : event.target.value;
        }
        /* check validation */
        for (let validator of this.state.registerFormControl[event.target.name].validators) {
            inputError = validator(event.target.value);
            if (inputError) break;
        }


        this.setState({
            registerFormControl: {
                ...this.state.registerFormControl,
                [event.target.name]: {
                    ...this.state.registerFormControl[event.target.name],
                    value: event.target.value,
                    error: inputError,
                    valid: Boolean(!inputError)
                }
            },
        }, () => {

            if (inputError) {
                this.setState({ formValid: false });
            } else {
                let formValid = true;
                for (let control of Object.keys(this.state[formName])) {
                    if (!this.state[formName][control].valid) {
                        formValid = false;
                        break;
                    }
                }
                this.setState({ formValid: formValid });
            }

        });
    };


    phonenumberValidations = (event, formName) => {

        let inputError = ''
        event.target.value = event.target.value.replace(/[^0-9()\s-]/g, '');
        const eventValue = event.target.value ? mobileNumberFormat(event.target.value, this.state.registerFormControl.phonenumber.value) : '';
        event.target.value = eventValue ? eventValue : event.target.value;

        for (let validator of this.state.registerFormControl.phonenumber.validators) {
            inputError = validator(event.target.value);
            if (inputError) break;
        }

        this.setState({
            [formName]: {
                ...this.state[formName],
                phonenumber: {
                    ...this.state[formName].phonenumber,
                    value: event.target.value,
                    valid: Boolean(!inputError),
                    error: inputError
                }
            }
        });
    }

    editPhNumberFn = () => {
        this.setState({ phoneNumberDisabled: false })
    }

    showPhoneVerifyModel = () => {
        this.setState({
            reactivationMsg: '',
            userUpdateStatus: false,
        })
        let value = this.state.registerFormControl.phonenumber.value.replace(/\D/g, '');
        const data = {
            "data": {
                "mobile": value
            }
        };
        AuthService.checkDetails(data).then(res => {
            const result = res.data.data;
            if (result.valid) {
                this.setState({
                    showPhoneNumberModel: true,
                    errorMsg: ''
                })
            } else {
                this.setState({
                    registerFormControl: {
                        ...this.state.registerFormControl,
                        phonenumber: {
                            ...this.state.registerFormControl.phonenumber,
                            error: result.message
                        }
                    }
                });
            }
        }).catch(error => {
            if (error.ctbidserrorcode == "CBBY001") {
                this.setState({
                    showReactivationModel: true,
                    mobileReacitvation: true,
                    showDeletedSuccessMsg: true,
                    errorMsg: ''
                })
            }
            else if (error.ctbidserrorcode == "CBBY009" || error.ctbidserrorcode == "CBBY017" || error.ctbidserrorcode == "CBBY019") {
                this.setState({
                    registerFormControl: {
                        ...this.state.registerFormControl,
                        phonenumber: {
                            ...this.state.registerFormControl.phonenumber,
                            error: error.message
                        }
                    }
                })
            }
            else if (error.ctbidserrorcode == "CBBY010") {
                this.setState({
                    showReactivationModel: true,
                    mobileReacitvation: true,
                    userUpdateStatus: true,
                    errorMsg: ''
                })
            } else {
                this.setState({
                    errorMsg: error.message
                })

            }
        })
    }


    onMobileChange = (event) => {
        let value = event.target.value.replace(/\D/g, '');

        this.setState({
            mobile: {
                ...this.state.mobile,
                otp: {
                    ...this.state.mobile.otp,
                    value: value
                }
            }
        });
    };


    handleRetry = () => {
        this.setState({ retryInProgress: true });
        this.setState({ loading: true });
        axios.post(getBuyersUrl('/api/v1/buyer/user/reset/password '), JSON.stringify({ data: { email: this.state.registerFormControl.email.value } }), getBuyerHeaders())
            .then(response => {
                if (response.status === 200) {
                    this.setState({
                        timeLeft: 105,
                        retry: false,
                        retryInProgress: false
                    }, () => {
                        this.startCountdown(); 
                    });
                }
            })
            .catch(error => {
                this.setState({ loading: false });
            });
    };

    formatTime = (totalSeconds) => {
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        return `${minutes}:${seconds.toString().padStart(2, '0')}`;
      };

      startCountdown = () => {
        this.timer = setInterval(() => {
          const { timeLeft } = this.state;
    
          if (timeLeft <= 1) {
            clearInterval(this.timer);
            this.setState({ timeLeft: 0, retry: true });
          } else {
            this.setState({ timeLeft: timeLeft - 1 });
          }
        }, 1000);
      };
    


    hideMobileModal = () => {
        this.setState({
            ...this.state,
            showPhoneNumberModel: false,
            isOtpSent: false,
            otpMessage: '',
            otpSuccess: false,
            mobile: {
                ...this.state.mobile,
                otp: {
                    ...this.state.mobile.otp,
                    value: ''
                }
            }

        });
    }

    changeEmail = (event) => {
        this.setState({
            ...this.state,
            reactivationEmail: {
                ...this.state.reactivationEmail,
                value: event.target.value
            }
        })
    }

    closeReactivationModel = () => {
        this.setState({
            ...this.state,
            showReactivationModel: false,
            showEmailReacicationModel: false,
            mobileReacitvation: false,
            messagetype: true,
            registerFormControl: {
                ...this.state.registerFormControl,
                email: {
                    ...this.state.registerFormControl.email,
                    value: '',
                    valid: false,
                    error: '',
                }
            },
            reactivationEmail: {
                value: ''
            },
            reactivationMsg: '',


        });
    }
    closeMobileReactivationModel = () => {
        this.setState({
            ...this.state,
            showReactivationModel: false,
            showEmailReacicationModel: false,
            mobileReacitvation: false,
            reactivationMsg: ''

        });
    }
    reactivation = () => {
        this.setState({
            reactiveBtn: true
        })

        const data = {
            "email": this.state.formControls.email.value && this.state.activeKey === 'Sign-In' ? this.state.formControls.email.value : this.state.registerFormControl.email.value
        }
        if (this.state.registerFormControl.phonenumber.value) {
            data['mobile'] = this.state.registerFormControl.phonenumber.value.replace(/\D/g, '');
        }

        AuthService.reActivation({ "data": data }).then(res => {
            this.setState({
                ...this.state,
                messagetype: true,
                reactivationMsg: 'An email has been sent to reactivate your account.',
                reactiveMobileNumber: false
            });
            setTimeout(() => {

                this.setState((prevState) => ({
                    ...this.state,
                    mobile: {
                        ...this.state.mobile,
                        otp: {
                            ...this.state.mobile.otp,
                            value: '',
                        }
                    },
                    signUpLading: false,
                    welcomeMessageShow: true,
                    reactiveBtn: false,
                    otpMessage: '',
                    isOtpSent: false,
                    otpSuccess: false,
                    showPhoneNumberModel: false,
                    reactivationMsg: '',
                    showReactivationModel: false,
                    registerFormControl: Object.fromEntries(
                        Object.entries(prevState.registerFormControl).map(([key, field]) =>
                            [key, { ...field, value: '', valid: false, error: '' }]
                        )
                    ),
                }));

            }, 4000);

        }).catch(error => {
            this.setState({
                reactiveMobileNumber: false,
                reactiveBtn: false,
                messagetype: false,
                reactivationMsg: error.message
            })
        })
    }

    /* get longer token validity */
    keepMeSignin = (event) => {
        this.setState({ remember: event.target.checked });
    };

    onSignin = (event) => {
        event.preventDefault();
        if (this.state.formValid) {
            this.setState({
                signInError: ''
            });
            store.dispatch({ type: 'SET_SIGNIN_FORM_LOADING', payload: true });
            const data = {
                data: {
                    username: this.state.formControls.email.value,
                    password: btoa(this.state.formControls.password.value),
                    'keep-user-logged-in': this.state.remember
                }
            };

            /* api call to get user token */
            AuthService.logIn(data)
                .then((response) => {
                    // const temp = {};
                    // temp.push(response);

                    const jsonData = response.data;
                    loginWithRes({ [ACCESS_TOKEN]: jsonData['accessToken'], [REFRESH_TOKEN]: jsonData['refreshToken'] }, { props: this.props }).then(
                        userData => {
                            //this.logRocketSetUp();

                            this.handleJiraButton(false, true);
                            const paramsValue = this.props.history.location.search;
                            const decoded = Buffer.from(paramsValue, "base64").toString("ascii");

                            setPmSteps(userData);
                            if (this.props.toggleSignInModal.fromBannerBtn) {
                                pmAutoNavigateToNextScreen(this.props, this.props.user, null, null, null, false, false, this.props.toggleSignInModal.fromBannerBtn);
                            }
                            let dataLayerData = {
                                'event': 'sign_in',
                                'title': this.props?.user?.id
                            }
                            addDataLayer(dataLayerData)
                        }
                    );
                    // const jsonData = {}
                })
                .catch((error) => {
                    store.dispatch({ type: 'SET_SIGNIN_FORM_LOADING', payload: false });
                    // TODO: Error message handle
                    this.setState({
                        showReactivationModel: false
                    })
                    if (error.ctbidserrorcode === 'CBBY015') {
                        this.setState({
                            showReactivationModel: true
                        })

                    } else {
                        this.setState({
                            signInError: error.message
                        });

                    }

                });
        }
    }

    /* Called when close button click */


    /** Called when tab click */
    onSelect = (key) => {

        /** Setting which tab is active */
        this.setState({
            activeKey: key,
            formValid: false
        });
    }

    /** Called when bottom page link click */
    tabNavigate = () => {

        /** Based on active key page is redirecting */
        this.setState({
            activeKey: this.state.activeKey === 'Sign-Up' ? 'Sign-In' : 'Sign-Up'
        })
    }

    responseGoogle = async (response) => {
        const data = {
            data: {
                token: response.tokenObj.id_token
            }
        };

        this.socialMediaSignInAndSignUp(data, 'google', response);
    };

    responseFacebook = async (response) => {

        if (response.status !== 'unknown') {
            const data = {
                data: {
                    token: response.accessToken
                }
            };
            this.socialMediaSignInAndSignUp(data, 'facebook', response);
        }
    };

    /** Called after sing complete in Apple */
    responseApple = async (response) => {
        this.setState({
            proxyEmail: false
        }, () => {
            this.appleSignHandle(response);
        });
    };

    appleSignHandle = (response) => {
        if (!this.state.proxyEmail) {
            const data = {
                data: {
                    user: {},
                    token: response['authorization']['id_token']
                }
            };

            if (response.hasOwnProperty('user')) {
                data['data']['user']['email'] = response['user']['email'];
                data['data']['user']['firstname'] = response['user']['name']['firstName'];
                data['data']['user']['lastname'] = response['user']['name']['lastName'];
            }
            ;
            this.socialMediaSignInAndSignUp(data, 'apple', response);

        }
    }

    compareNewField = (value) => {
        if (value === this.state.registerFormControl.newPassword.value) return '';

        return 'Password does not match';
    };

    signUpSubmit = (event) => {
        event.preventDefault();
        this.setState({
            signUpLading: true,
            signUpError: ''
        })
        const data = {
            data: {
                firstname: this.state.registerFormControl.firstname.value,
                lastname: this.state.registerFormControl.lastname.value,
                nickname: this.state.registerFormControl.nickname.value,
                email: this.state.registerFormControl.email.value,
                // utmsource: this.props.googleAdsValue.user_type ? this.props.googleAdsValue.user_type : null,
                // utmcampaign: this.props.googleAdsValue.campaign_type ? this.props.googleAdsValue.campaign_type : null,
                mobile: this.state.registerFormControl.phonenumber.value.replace(/\D/g, '')
            }
        };
        if (this.state.userUpdateStatus) {
            this.updateUserFn()
        }
        else {
            this.registerAPICall(data);
        }

    }

    registerAPICall = (data) => {
        this.setState({
            displayname: data.data.firstname + ' ' + data.data.lastname
        });
        authService.registerAPI(data).then(
            response => {
                this.setState({
                    signUpLading: false,
                    welcomeMessageShow: true,
                    disabledText: true
                },()=>{
                    this.startCountdown();
                });
            }
        ).catch((error) => {
            this.setState({
                signUpLading: false,
                signUpError: error.message
            });
            // TODO: Error message handle
        });
    }

    /* validation of password strength */
    checkPasswordStrength = (password) => {
        const lowerRegExp = new RegExp("^(?=.*[a-z])");
        const upperRegExp = new RegExp("^(?=.*[A-Z])");
        const numericRegExp = new RegExp("^(?=.*[0-9])");
        const lengthRegExp = new RegExp("^(?=.{8,15})");
        const symbolRegExp = new RegExp(/[ `!@#$%^&*]/);

        let strength = {
            status: 0,
            lower: false,
            upper: false,
            numeric: false,
            symbol: false,
            count: false
        };

        /* check for lowercase character in password */
        if (lowerRegExp.test(password)) {
            strength.status += 1;
            strength.lower = true;
        }

        /* check for uppercase character in password */
        if (upperRegExp.test(password)) {
            strength.status += 1;
            strength.upper = true;
        }

        /* check for number in password */
        if (numericRegExp.test(password)) {
            strength.status += 1;
            strength.numeric = true;
        }

        /* check for Minimum 8 - Maximum 15 characters */
        if (lengthRegExp.test(password) && password.length < 16) {
            strength.status += 1;
            strength.count = true;
        }

        /* check for symbol in password */
        if (symbolRegExp.test(password)) {
            strength.status += 1;
            strength.symbol = true;
        }

        /* set password strength */
        this.setState({ passwordStrength: { ...strength } });

        if (!password || strength.status === 5) {
            return '';
        }

        return 'Password should follow rules';
    };

    terms = () => {
        // this.handleClose();
        // this.props.history.push('/terms');
        window.open("/terms", '_blank');
    }


    compareRetypeField = (value) => {
        if (this.state.registerFormControl.retypePassword.value) {
            setTimeout(() => {
                if (this.state.registerFormControl.retypePassword.value !== value) {
                    this.setState({
                        registerFormControl: {
                            ...this.state.registerFormControl,
                            retypePassword: {
                                ...this.state.registerFormControl.retypePassword,
                                error: 'Password does not match',
                                valid: false
                            }
                        },
                        formValid: false
                    });
                } else if (this.state.registerFormControl.retypePassword.value === value) {
                    this.setState({
                        registerFormControl: {
                            ...this.state.registerFormControl,
                            retypePassword: {
                                ...this.state.registerFormControl.retypePassword,
                                error: '',
                                valid: true
                            }
                        }
                    });
                    this.setState({ formValid: Validators.checkFormValid({ ...this.state.registerFormControl }) });
                }
            });
        }

        return '';
    };





    nicknameCheck = (event) => {
        const check = this.state.registerFormControl.nickname.valid;
        // this.formatData(event, !check);
    }

    formatData = (event, valid) => {
        if ((event.target.name === "nickname" || event.target.name === "email" || event.target.name === "firstname" || event.target.name === "lastname") && !valid) {
            this.setState({
                details: {
                    ...this.state.details,
                    [event.target.name]: {
                        ...this.state.details[event.target.name],
                        loading: true
                    }
                }
            }, () => {
                if (event.target.name === "email" && event.target.value === this.state.registerFormControl.retypeEmail.value && this.state.nameError) {
                    this.setState({
                        formValid: true
                    })
                }
                const data = {
                    data: {
                        [event.target.name]: event.target.value
                    }
                };
                this.checkDetails(data, event.target.name);
            });
        }

    }
    signInOpen = (flag) => {
        store.dispatch({ type: 'TOGGLE_SIGNIN_MODAL', payload: { open: true, mode: flag } });
    };

    checkDetails = (data, name) => {
        AuthService.checkDetails(data).then(res => {
            const result = res.data.data;
            if (name === 'email') {
                this.setState({
                    errorMsg: ''
                })
            }
            if (name === 'nickname') {
                this.setState({
                    nickNameErroMsg: ''
                })
            }
            this.setState({
                details: {
                    ...this.state.details,
                    [name]: {
                        loading: false,
                        exists: !result.valid,
                        message: result?.message
                    }
                }
            });
        }).catch(error => {
            if (name === 'email') {
                if (error.ctbidserrorcode == "CBBY001") {
                    this.setState({
                        showReactivationModel: true,
                        showDeletedSuccessMsg: true,
                    })
                }
                else if (error.ctbidserrorcode == "CBBY008" || error.ctbidserrorcode == "CBBY009" || error.ctbidserrorcode == "CBBY010" || error.ctbidserrorcode == "CBBY016" || error.ctbidserrorcode == "CBBY017" || error.ctbidserrorcode == "CBBY018") {
                    this.setState({
                        ...this.state,
                        registerFormControl: {
                            ...this.state.registerFormControl,
                            [name]: {
                                ...this.state.registerFormControl[name],
                                valid: !Boolean(error.message),
                                error: error.message
                            }
                        }
                    })
                }
                else {
                    this.setState({
                        errorMsg: error.message
                    })
                }
            }
            if (name === "firstname" || name === "lastname") {
                if (error.ctbidserrorcode == "CBBY014" || error.ctbidserrorcode == "CBBY016") {
                    this.setState({
                        ...this.state,
                        registerFormControl: {
                            ...this.state.registerFormControl,
                            [name]: {
                                ...this.state.registerFormControl[name],
                                valid: !Boolean(error.message),
                                error: error.message
                            }
                        }
                    })

                }
            }
            if (name === 'nickname') {
                if (error.ctbidserrorcode == "CBBY001" || error.ctbidserrorcode == "CBBY010" || error.ctbidserrorcode == "CBBY008" || error.ctbidserrorcode == "CBBY014" || error.ctbidserrorcode == "CBBY016") {
                    this.setState({
                        ...this.state,
                        registerFormControl: {
                            ...this.state.registerFormControl,
                            [name]: {
                                ...this.state.registerFormControl[name],
                                valid: !Boolean(error.message),
                                error: error.message
                            }
                        }
                    })

                } else {
                    this.setState({
                        nickNameErroMsg: error.message
                    })
                }
            }
            this.setState({
                signUpError: name === 'email' || name === 'nickname' ? '' : this.state.signUpError,

                details: {
                    ...this.state.details,
                    [name]: {
                        loading: false,
                        exists: false,
                    }
                }
            });
            console.error(error);
        });
    }


    clearConsole = () => {
    }

    handleJiraButton = (flag, forceUpdate = false) => {
        if (!this.props.toggleSignInModal.open || forceUpdate) {
            showAndHideJiraButton(flag);
        }
    }

    showTermsAndCondition = () => {
        this.setState({
            signTermsConditions: true
        })
    }

    handleCloseTerms = () => {
        this.setState({
            signTermsConditions: false
        })
    }

    render() {
        const isButtonDisabled = Object.values(this.state.registerFormControl).some(field => !field.valid) || this.state.signUpError || this.state.nickNameErroMsg || Boolean(this.state.details.email.message) || Boolean(this.state.details.nickname.message);

        return (
            <div className="sign-in-container" id="sign-in-modal">

                <div className="signup-page">
                    <div className="left-panel">
                        <div className="first-row top-align mt-4">
                            <div className="tile text yellow">Declutter easily<div>with CTBids</div></div>
                            <div className="tile image"> <img src={banner2} alt="banner2" /> </div>
                            <div className="tile text red"> Bid at lowest prices  <div>on what you love</div><div>the most</div></div>
                            <div className="tile image"> <img src={banner4} alt="banner4" /></div>
                        </div>

                        <div className="second-row bottom-align">
                            <div className="tile image"><img src={banner1} alt="banner1" style={{ borderTopLeftRadius: 0, borderTopRightRadius: 0 }}/></div>
                            <div className="tile text blue"> Find hidden gems  <div>from nearest estate sales</div></div>
                            <div className="tile image">   <img src={banner3} alt="banner3" /> </div>
                            <div className="tile text gray"> Become a part of our family with Caring Transition</div>
                        </div>
                    </div>

                    <div className={"right-panel" } style={{height: this.props.history.location.pathname.includes('/set-password') ? "50%" :'', minHeight: this.props.history.location.pathname.includes('/set-password') ? "600px" :''}}>
                        {this.props.history.location.pathname.includes('/set-password') ? <SetPassword {...this.props} /> : <div className='w-100' >
                            <div className="d-flex align-items-center justify-content-between mb-4">
                                <div className="d-flex align-items-center gap-2">
                                    <div className='text-bold register-to'>Register {window.innerWidth > 600 && `to`}</div>
                                   {window.innerWidth > 600 &&  <div style={{marginTop: '10px'}}>
                                        <img
                                            src={`${process.env.PUBLIC_URL}/static/logo/CTBids_logo.png`}
                                            width="130px"
                                            alt="CTBids Logo"
                                        />
                                    </div>}
                                </div>

                                <div className="ms-auto">
                                    <button onClick={() => { this.signInOpen('Sign-In'); }} className="btn signin-btn">Already registered? <span>Sign in</span></button>
                                </div>
                            </div>

                            <Form onSubmit={this.signUpSubmit}>
                                <Form.Group controlId="firstname">
                                    <Form.Label className="required text-bold f-16">First Name</Form.Label>
                                    <Form.Control type="text"  className='f-16 custom-input' disabled={this.state.disabledText} placeholder="First Name" name="firstname" value={this.state.registerFormControl.firstname.value} onChange={(event) => this.onInputValidation(event, 'registerFormControl')} autoFocus />
                                    <div className="text">
                                        {
                                            this.state.registerFormControl.firstname.error ? <small className="text-danger">{this.state.registerFormControl.firstname.error}</small> : null
                                        }
                                    </div>
                                </Form.Group>
                                <Form.Group controlId="lastname f-16" style={{ marginTop: '10px' }}>
                                    <Form.Label className="required text-bold f-16">Last Name</Form.Label>
                                    <Form.Control type="text"  className='f-16 custom-input' disabled={this.state.disabledText} placeholder="Last Name" name="lastname" value={this.state.registerFormControl.lastname.value} onChange={(event) => this.onInputValidation(event, 'registerFormControl')} />
                                    <div className="text">
                                        {
                                            this.state.registerFormControl.lastname.error ? <small className="text-danger">{this.state.registerFormControl.lastname.error}</small> : null
                                        }
                                    </div>
                                </Form.Group>
                                <Form.Group controlId="lastname" style={{ marginTop: '10px' }}>
                                    <Form.Label className="required text-bold f-16">User name for display purpose</Form.Label>
                                    <Form.Control  className='f-16 custom-input' disabled={this.state.disabledText} type="text" placeholder="User Name" name="nickname" value={this.state.registerFormControl.nickname.value} onChange={(event) => this.onInputValidation(event, 'registerFormControl')} onBlur={(event) => this.nicknameCheck(event)} />
                                    <div className="text">
                                        {
                                            this.state.registerFormControl.nickname.error ? <small className="text-danger">{this.state.registerFormControl.nickname.error}</small> : null
                                        }
                                        {
                                            this.state.details.nickname.loading ?
                                                <div>
                                                    <small>Checking username <Spinner animation="border" style={{ marginTop: '5px', width: '1rem', height: '1rem' }}  variant="info" /> </small>
                                                </div> : <div>
                                                    {
                                                        !this.state.registerFormControl.nickname.error &&
                                                            this.state.registerFormControl.nickname.value &&
                                                            this.state.details.nickname.exists ?
                                                            <small className='text-danger'>{this.state.details.nickname.message}</small> : null
                                                    }
                                                </div>
                                        }
                                    </div>
                                </Form.Group>
                                <Form.Group controlId="email" className="email" style={{ marginTop: '10px' }}>
                                    <Form.Label className="required text-bold">Email</Form.Label>

                                    <Form.Control type="email"  className='f-16 custom-input' disabled={this.state.disabledText} value={this.state.registerFormControl.email.value} placeholder="@ Your email" name="email" onChange={(event) => this.emailValidation(event, 'registerFormControl')} />
                                    <div className="text">
                                        {
                                            this.state.registerFormControl.email.error ? <small className="text-danger">{this.state.registerFormControl.email.error}</small> : null
                                        }
                                        {
                                            this.state.details.email.loading ?
                                                <div>
                                                    <small>Checking email <i className='fa fa-spinner fa-spin'></i></small>
                                                </div> : <div>
                                                    {
                                                        !this.state.registerFormControl.email.error &&
                                                            this.state.registerFormControl.email.value &&
                                                            this.state.details.email.exists ?
                                                            <small className='text-danger'>{this.state.details.email.message}</small> : null
                                                    }
                                                </div>
                                        }
                                    </div>
                                </Form.Group>
                                <Form.Group controlId="confirmEmail" style={{ marginTop: '10px' }}>
                                    <Form.Label className="required text-bold">Retype Email</Form.Label>
                                    <Form.Control  className='f-16 custom-input' disabled={this.state.disabledText} type="email" placeholder="@ Your email" name="retypeEmail" value={this.state.registerFormControl.retypeEmail.value} onChange={(event) => this.emailValidation(event, 'registerFormControl')} onPaste={(event) => event.preventDefault()} autocomplete="off" />
                                    <div className="text">
                                        {
                                            this.state.registerFormControl.retypeEmail.error ? <small className="text-danger">{this.state.registerFormControl.retypeEmail.error}</small> : null
                                        }
                                    </div>
                                </Form.Group>

                                <Form.Group className="email">
                                    <div className="d-flex justify-content-between align-items-center w-100">
                                        <Form.Label className="required text-bold" style={{ whiteSpace: 'nowrap', marginTop: '10px' }}>Phone Number</Form.Label>
                                        {this.state.isVerified && this.state.tempVerifyPhoneNumber == this.state.registerFormControl.phonenumber.value ?
                                            <div className="text-success right-text me-5" style={{ marginRight: '55px' }}>
                                                Verified
                                            </div> :
                                            <Form.Text className="text-muted passcode-msg text-end f-16">
                                                You will need to verify with a one time passcode
                                            </Form.Text>
                                        }
                                    </div>
                                    <div className='d-flex f-16'>
                                        <Form.Control  className='f-16 custom-input' type="text"  placeholder="Enter phone number" disabled={this.state.phoneNumberDisabled || this.state.disabledText} name="phonenumber" value={this.state.registerFormControl.phonenumber.value} onChange={(event) => this.phonenumberValidation(event, "registerFormControl")} />
                                        {this.state.isVerified && this.state.tempVerifyPhoneNumber == this.state.registerFormControl.phonenumber.value ? <Button style={{ marginLeft: '5px', padding: "5px" }} onClick={() => this.editPhNumberFn()} variant="secondary">Edit</Button>
                                            : <Button disabled={isButtonDisabled || this.state.nickNameErroMsg || this.state.signUpError} style={{ marginLeft: '5px', padding: "5px" }} onClick={() => this.showPhoneVerifyModel()} variant="secondary">Verify</Button>}
                                    </div>
                                    <div className="text">
                                        {
                                            this.state.registerFormControl.phonenumber.error ? <small className="text-danger">{this.state.registerFormControl.phonenumber.error}</small> : null
                                        }
                                    </div>
                                </Form.Group>

                                <div className="form-check mt-3">
                                    <input
                                        className="form-check-input f-16 custom-input"
                                        type="checkbox"
                                        id="termsCheck"
                                        checked={this.state.acceptTerms}
                                        onChange={(e) => this.setState({ acceptTerms: e.target.checked })}
                                        style={{border: '1px solid #bfb2b2'}}
                                    />
                                    <label className="form-check-label terms-and-condition f-18" htmlFor="termsCheck">
                                        Accept Our{" "}
                                        <span
                                            className="clickable terms"
                                            onClick={() =>
                                                window.open(
                                                    "https://assets.ctbids.com/buyer/CTBidsTermsandConditions1.10.25.pdf",
                                                    "_blank"
                                                )
                                            }
                                            style={{ color: "#007bff", textDecoration: "underline", cursor: "pointer" }}
                                        >
                                            Terms and Conditions
                                        </span>.
                                    </label>
                                </div>

                                <div className='text-center verification-msg mt-4 f-18'>
                                    <p>Verification link would be send to your registered email address to create account password.</p>
                                </div>
                                {this.state.signUpError ? (
                                    <div className="api-error mb-4">
                                        {this.state.signUpError}
                                    </div>
                                ) : this.state.errorMsg ? (
                                    <div className="api-error mb-4">
                                        {this.state.errorMsg}
                                    </div>
                                ) : this.state.nickNameErroMsg ? (
                                    <div className="api-error mb-4">
                                        {this.state.nickNameErroMsg}
                                    </div>
                                ) : null}

                                <Button variant="secondary" className='w-100 mt-4 d-flex justify-content-center align-items-center verification-btn f-18' type="submit" disabled={isButtonDisabled || !this.state.isVerified || this.state.errorMsg || !this.state.acceptTerms || (this.state.tempVerifyPhoneNumber !== this.state.registerFormControl.phonenumber.value) || this.state.disabledText}>
                                {!this.state.disabledText ? 'Send verification email now' : 'Verification link sent to your email'} <span className='d-flex align-items-center' style={{marginLeft: '5px'}}>  {!this.state.disabledText  ? rightArrow : check}</span>
                                    {' '}
                                    {this.state.signUpLading && <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" />}
                                </Button>

                                {this.state.disabledText && <div className="retry-text f-18" style={{ textAlign: 'center', marginTop: '10px' }}>
                                     Haven’t received the mail yet?
                                    {this.state.retry ? 
                                        <button onClick={this.handleRetry} disabled={this.state.retryInProgress}
                                            style={{  background: 'none',  border: 'none',  textDecoration: 'underline',
                                                cursor: this.state.retryInProgress ? 'not-allowed' : 'pointer' }} >
                                             Retry
                                        </button> : <span style={{textDecoration: 'underline'}}> Retry in {this.formatTime(this.state.timeLeft)} seconds</span>
                                    }
                                </div>}

                                <div className="social-login">
                                    <ScmSignin {...this.props} />
                                </div>


                            </Form>

                        </div>}
                    </div>

                </div>


                <Modal centered show={this.state.showReactivationModel} className="change-mobile-modal" onHide={() => { this.setState({ ...this.state }) }}>
                    <Modal.Body>
                        {!this.state.mobileReacitvation ?
                            <div >
                                <p className='text-center'>This email address is already associated with an account that has been deleted. Would you like to reactivate your account?</p>

                                {this.state.reactivationMsg && <div className={`${this.state.messagetype ? 'text-success' : 'text-danger'} text-center mt-3`}>
                                    {this.state.reactivationMsg}
                                </div>}

                                <div className="d-flex justify-content-center align-items-center mt-3">
                                    <Button className='me-2' onClick={() => this.closeReactivationModel()}>No</Button>
                                    <Button variant="secondary mx-2" disabled={this.state.reactiveBtn} onClick={() => this.reactivation()}>Yes</Button>
                                </div>
                            </div> :
                            <div>
                                {this.state.userUpdateStatus ?
                                    <p className='text-center'>This phone number is already associated with another account. Would you like to verify this account to update your account information then select ‘Sign Up’?</p> :
                                    <p className='text-center'>This phone number is already associated with an account that has been deleted. Would you like to verify    your phone number and update account information?</p>
                                }

                                {this.state.reactivationMsg && <div className='text-success text-center mt-3'>
                                    {this.state.reactivationMsg}
                                </div>}
                                <div className="d-flex justify-content-center align-items-center mt-3">
                                    <Button className='me-2' onClick={() => this.closeMobileReactivationModel()}>No</Button>
                                    <Button variant="secondary mx-2" onClick={() => this.setState({ showPhoneNumberModel: true, showReactivationModel: false, reactiveMobileNumber: true })}>Yes</Button>

                                </div>
                            </div>
                        }
                    </Modal.Body>
                </Modal>


                <Modal centered show={this.state.showPhoneNumberModel} className="change-mobile-modal" onHide={() => { this.setState({ ...this.state }) }}>
                    <Modal.Body>
                        <div className="profile-modal-close-icon clickable" onClick={this.hideMobileModal}></div>
                        <div className="d-flex flex-column justify-content-center align-items-center w-100">
                            <div className="mb-3 text-bold" style={{ width: "90%" }}>  
                                <Form.Group>
                                    <Form.Label className="required">Phone Number</Form.Label>
                                    <Form.Control type="text" id="newMobile" name="newMobile" placeholder=" " style={{ cursor: 'not-allowed', caretColor: "transparent", }}
                                        value={this.state.registerFormControl.phonenumber.value} />

                                    <div className="text">
                                        {
                                            this.state.registerFormControl.phonenumber.error ? <small className="error">{this.state.registerFormControl.phonenumber.error}</small> : null
                                        }
                                    </div>
                                </Form.Group>
                            </div>
                            {this.state.isOtpSent &&
                                <div className="" style={{ width: "90%" }}>
                                    <Form.Group>
                                        <Form.Label className="required text-bold">OTP
                                            <sup>
                                                <OverlayTrigger
                                                    placement="right"
                                                    overlay={
                                                        <Tooltip id="otp-tooltip" className="custom-tooltip">
                                                             OTP (One-Time Password) Verifies identity, authenticates email and ensures secure user creation
                                                        </Tooltip>
                                                    } >
                                                    <img
                                                        src={`${process.env.PUBLIC_URL}/static/icons/common-icons/info.svg`}
                                                        style={{ width: '12px', marginLeft: '3px', cursor: 'pointer' }}
                                                        alt="info-icon"
                                                    />
                                                </OverlayTrigger>
                                            </sup>
                                        </Form.Label>
                                        <Form.Control  type="text" id="otp" name="otp" maxLength={6} placeholder="Enter OTP" value={this.state.mobile.otp.value}   onChange={(event) => this.onMobileChange(event)} />
                                    </Form.Group>
                                </div>
                            }
                            <div className="mt-2">

                                <div className={`${this.state.otpSuccess ? 'text-success' : 'text-danger'} text-center m-3`}>
                                    {
                                        this.state.otpMessage ? <div >{this.state.otpMessage}</div> : null
                                    }
                                </div>

                                {
                                    this.state.isOtpSent ?
                                        <div className="d-flex flex-column justify-content-center align-items-center flex-sm-row">
                                            <Button variant="secondary" disabled={this.state.mobile.otp.value == '' || this.state.reactiveBtn} onClick={() => { this.submitOtp() }}>
                                                Verify
                                            </Button>
                                        </div> :
                                        <div className="d-flex justify-content-center align-items-center">
                                            <Button variant="outline-dark btn-white mx-2" onClick={() => { this.generateOtp('call') }}>
                                                Call me {
                                                    this.state.loaderHandle === 'call' ?
                                                        <Spinner className="ml-1" animation="border" as="span" size="sm" /> :
                                                        null
                                                }
                                            </Button>
                                            <Button variant="secondary" onClick={() => { this.generateOtp('sms') }}>
                                                Text me  {
                                                    this.state.loaderHandle === 'sms' ?
                                                        <Spinner className="ml-1" animation="border" as="span" size="sm" /> :
                                                        null
                                                }
                                            </Button>

                                        </div>
                                }
                                {
                                    this.state.isOtpSent ? <div className="mt-2 text-center">
                                        Not received? <span className="change-email-link clickable" onClick={() => this.resendOtpfn()}>
                                            Resend {
                                                this.state.resendOtp ?
                                                    <Spinner className="ml-1" animation="border" as="span" size="sm" /> :
                                                    null
                                            }
                                        </span>
                                    </div> : null
                                }
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
                <Modal centered className="terms-dialog" id="terms-and-condition" show={this.state.signTermsConditions} animation={false} backdrop="static" keyboard={false}>
                    <Modal.Body>
                        <SignTermsAndCondtions />
                        <div className="d-flex align-items-center justify-content-center actions" style={{ marginTop: "2rem" }}>
                            <Button variant="secondary mx-2" onClick={this.handleCloseTerms}>Close</Button>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}